<template>
  <div :class="['ranking-display', rightBottom ? 'right-ranking-display' : '']">
    <!-- <img :src="require('@/assets/daping/xcmx.png')" class="xcmx-img" v-if="imgType != '1'"/>
    <img :src="require('@/assets/daping/zgxqy.png')" class="zgxqy-img" v-else/> -->
    <img
      :src="require('@/assets/daping/base.svg')"
      :class="[rightBottom ? 'right-base-img' : 'base-img']"
    />
    <div class="ranking-data" :style="{ marginLeft: marginLeft ? '180px' : '' }">
      <div v-for="(item, index) in rankingDataList" :key="index" :class="['list']">
        <img :src="item.img" class="ranking-data-img" />
        <div class="name-num">
          <div class="name">{{ item.label }}</div>
          <div class="num" v-if="!isName">
            <span v-if="!isValue"> {{ item.autoComputedRate }}% </span>
            <span v-else> {{ item.value }}条 </span>
          </div>
          <div class="num" v-else>{{ item.value2 }}人</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "index",
  components: {},
  props: {
    rankingDataList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    imgType: {
      type: String,
      default: "",
    },
    isName: {
      type: Boolean,
      default: false,
    },
    isValue: {
      type: Boolean,
      default: false,
    },
    marginLeft: {
      type: Boolean,
      default: false,
    },
    rightBottom: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
<style scoped lang="less">
.ranking-display {
  width: 727px;
  height: 104px;
  padding: 6px 0 12px 0px;
  display: flex;
  position: relative;
  .base-img {
    width: 727px;
    position: absolute;
    top: 65px;
  }
  .right-base-img {
    width: 395px;
    position: absolute;
    top: 46px;
  }
  .xcmx-img {
    width: 80px;
    height: 78px;
    margin-right: 23px;
  }
  .zgxqy-img {
    width: 112px;
    height: 78px;
    margin-right: 15px;
  }
  .ranking-data {
    display: flex;
    flex: 1;
    .list {
      display: flex;
      align-items: center;
      width: 33.3%;
      .name-num {
        margin: 10px 0 0 12px;
      }
      .name {
        font-family: MiSans, MiSans;
        font-weight: 400;
        font-size: 12px;
        color: #adc2d3;
        line-height: 22px;
      }
      .num {
        font-family: MiSans, MiSans;
        font-weight: 500;
        font-size: 16px;
        color: #e4f2ff;
        line-height: 22px;
        margin-top: 6px;
      }
    }
    .ranking-data-img {
      width: 60px;
      height: 53px;
    }
  }
}

.right-ranking-display {
  width: 395px;
  height: 50px;
  .ranking-data {
    padding: 0 20px;
    margin-top: 12px;
    .ranking-data-img {
      width: 35px;
      height: 30px;
    }
    .list {
      .name-num {
        margin: 6px 0 0 6px;
      }
      .num {
        margin-top: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/patrolScreenMini/components/ranking-display.vue